import Sidebar from '../utill/Sidebar';
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Button, Card, Form, Table} from "react-bootstrap";
import {ChangeEvent, useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import {
    Paper,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from "@mui/material";
import {reissue} from "../utill/UtilComponent";
import axios from "axios";
import dayjs, {Dayjs} from "dayjs";
import weekOfYear from 'dayjs/plugin/weekOfYear';
import 'dayjs/locale/ko';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import Loading from '../utill/Loading';
import {RootState} from "../../redux/store";
import StyledTableCell from "../utill/StyledTableCell"


function ActiveUserChart() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const [date, setDate] = useState([]);
    const [cnt, setCnt] = useState([]);
    const [periodSelected, setPeriodSelected] = useState("1");
    const [dailyStartDate, setDailyStartDate] = React.useState<any>(dayjs().startOf('day').locale('ko-KR'));
    const [weeklyStartDate, setWeeklyStartDate] = React.useState<any>(dayjs().startOf('day').locale('ko-KR'));
    const [monthlyStartDate, setMonthlyStartDate] = React.useState<any>(dayjs().startOf('day').locale('ko-KR'));
    const [endDate, setEndDate] = React.useState(dayjs().startOf('day').locale('ko'));
    const [data, setData] = useState<Date[]>([])
    const [areaCodeList, setAreaCodeList] = useState<area[]>([]);
    const [areaCode, setAreaCode] = useState('');
    const user = useSelector((state: RootState) => state.user.value);
    const [loading, setLoading] = useState(true);
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    let userId = user.id;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-활성 사용자 통계'
        if (auth.MENUAUTH?.STAT0100?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        setLoading(true);
        const currentDate = dayjs().subtract(6, 'month');
        const nearestSunday = currentDate.day(0);
        setWeeklyStartDate(nearestSunday);
        reissue(userId, url, navigate).then(() => {
            let startDtm = '';
            let endDtm = '';
            if(periodSelected === '1') {
                startDtm = dailyStartDate.format('YYYY-MM-DD 00:00:00');
                endDtm = endDate.format('YYYY-MM-DD 23:59:59');
            }else if(periodSelected === '2') {
                startDtm = weeklyStartDate.format('YYYY-MM-DD 00:00:00');
                endDtm = endDate.format('YYYY-MM-DD 23:59:59');
            }else if(periodSelected === '3') {
                startDtm = monthlyStartDate.startOf('month').format('YYYY-MM-DD 00:00:00')
                endDtm = endDate.endOf('month').format('YYYY-MM-DD 23:59:59');
            }
            axios.get(url + 'statistic/usage', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    type: periodSelected,
                    startDtm: startDtm,
                    endDtm: endDtm
                }
            }).then((response) => {
                setLoading(false);
                setData(response.data.result)
                setDate(response.data.result.map((item: { date: string; }) => {
                    const date = new Date(item.date);
                    date.setHours(0, 0, 0, 0);
                    return date;
                }));
                setCnt(response.data.result.map((item: { cnt: string; }) => item.cnt));
            })

            axios.get(url + 'statistic/areacode', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setAreaCodeList(response.data.result);
            })
        })
    }, []);

    const handleChartSubmit = async () => {
        setLoading(true);
        let startDtm = ''
        let endDtm = ''
        if (periodSelected === '1') {
            startDtm = dailyStartDate.format('YYYY-MM-DD 00:00:00');
            endDtm = endDate.format('YYYY-MM-DD 23:59:59');
        } else if (periodSelected === '2') {
            startDtm = weeklyStartDate.format('YYYY-MM-DD 00:00:00');
            endDtm = endDate.format('YYYY-MM-DD 23:59:59');
        } else if (periodSelected === '3') {
            startDtm = monthlyStartDate.startOf('month').format('YYYY-MM-DD 00:00:00');
            endDtm = endDate.endOf('month').format('YYYY-MM-DD 23:59:59');
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'statistic/usage', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    type: periodSelected,
                    startDtm: startDtm,
                    endDtm: endDtm,
                    areaCode: areaCode
                }
            }).then((response) => {
                setLoading(false);
                setData(response.data.result)
                setDate(response.data.result.map((item: { date: string; }) => {
                    const date = new Date(item.date);
                    date.setHours(0, 0, 0, 0);
                    return date;
                }));
                setCnt(response.data.result.map((item: { cnt: any; }) => item.cnt));
            })
        })
    }

    useEffect(() => {
        const currentDate = dayjs();
        const nearestSunday = currentDate.day(0);
        setWeeklyStartDate(nearestSunday);
    }, []);

    const handleChangePeriodSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setPeriodSelected(e.target.value)
    }

    let selectedValueContent = "";
    let dailyState = "active";
    let weeklyState = "inactive";
    let monthlyState = "inactive";

    if (periodSelected === "1"){
        selectedValueContent = "일자";
        dailyState = "active";
        weeklyState = "inactive";
        monthlyState = "inactive";
    } else if (periodSelected === "2"){
        selectedValueContent = "주차";
        dailyState = "inactive";
        weeklyState = "active";
        monthlyState = "inactive";
    } else if (periodSelected === "3"){
        selectedValueContent = "월";
        dailyState = "inactive";
        weeklyState = "inactive";
        monthlyState = "active";
    }


    const DailyEndDateChange = (newValue: Dayjs | null) => {
        if (!newValue) return;

        if (newValue.isBefore(dailyStartDate)) {
            setDailyStartDate((newValue.subtract(1, 'day')));
        }
        setEndDate(newValue);
    };

    const WeeklyEndDateChange = (newValue: Dayjs | null) => {
        if (!newValue) return;

        if (newValue.isBefore(weeklyStartDate)) {
            setWeeklyStartDate((newValue.subtract(6, 'day')));
        }
        setEndDate(newValue);
    };

    const MonthlyEndDateChange = (newValue: Dayjs | null) => {
        if (!newValue) return;

        if (newValue.isBefore(monthlyStartDate)) {
            setMonthlyStartDate((newValue.subtract(1, 'month')));
        }
        setEndDate(dayjs(newValue).date(1));
    };

    function format(num: string){
        const numericValue = parseInt(num, 10);
        return numericValue.toLocaleString()
    }

    const WeeklyFormat = (date: string) => {
        const day = dayjs(date);

        const weekOfYear = day.week();

        return `${day.year()}-${weekOfYear}`;
    };

    

    return (
        <div id="wrapper">
            <Sidebar menuCode={"STAT0100"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='활성 사용자 통계'/>
                        <Card className="card shadow mb-4">
                            <Card.Header className="py-3">
                                <h6 className="m-0 font-weight-bold text-primary">활성 사용자 통계 검색</h6>
                                <p className="mb-2 mt-2 basic_font">{selectedValueContent} 기준으로 조회 합니다.</p>
                                {loading ? <Loading /> : null}
                                <Form id="searchForm">
                                    <div className='form-group row'>
                                        <div className='search_area'>
                                            <Form.Select className="select_box" style={{marginTop:'8px', marginRight:'10px'}}
                                                         onChange={(e) => setAreaCode(e.target.value)}>
                                                {areaCodeList.map(area => (
                                                    <option key={area.code} value={area.code}>{area.name}</option>
                                                ))}
                                            </Form.Select>
                                            <Form.Select className='select_box' style={{marginTop:'8px'}} id='search_select'
                                                value={periodSelected} onChange={handleChangePeriodSelect}>
                                                <option value="1">일자별</option>
                                                <option value="2">주차별</option>
                                                <option value="3">월별</option>
                                            </Form.Select>
                                            <Form id={dailyState}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
                                                    <DemoContainer components={['DatePicker', 'DatePicker']} sx={{marginLeft:'1rem'}}>
                                                        <DatePicker
                                                            label="시작일자"
                                                            format='YYYY-MM-DD'
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={dailyStartDate}
                                                            onChange={setDailyStartDate}
                                                            defaultValue={dayjs()}
                                                            shouldDisableDate = {(day) => {
                                                                return day > endDate;
                                                            }}
                                                        />
                                                        <DatePicker
                                                            label="종료일자"
                                                            format='YYYY-MM-DD'
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={endDate}
                                                            onChange={DailyEndDateChange}
                                                            slots={{ textField: TextField }}
                                                            disableFuture
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </Form>
                                            <Form id={weeklyState}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
                                                    <DemoContainer components={['DatePicker', 'DatePicker']} sx={{marginLeft:'1rem'}}>
                                                        <DatePicker
                                                            label="시작일자"
                                                            format='YYYY-MM-DD'
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={weeklyStartDate}
                                                            onChange={setWeeklyStartDate}
                                                            defaultValue={dayjs().format('YYYY-MM-DD')}
                                                            shouldDisableDate = {(day) => {
                                                                return day.day() !== 0 || day > endDate;
                                                            }}
                                                        />
                                                        <DatePicker
                                                            label="종료일자"
                                                            format='YYYY-MM-DD'
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={endDate}
                                                            onChange={WeeklyEndDateChange}
                                                            slots={{ textField: TextField }}
                                                            disableFuture
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </Form>
                                            <Form id={monthlyState}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
                                                    <DemoContainer components={['DatePicker', 'DatePicker']} sx={{marginLeft:'1rem'}}>
                                                        <DatePicker
                                                            label='시작일자'
                                                            format='YYYY-MM'
                                                            views={['year', 'month']}
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={monthlyStartDate}
                                                            onChange={(newValue) => {
                                                                setMonthlyStartDate(dayjs(newValue).date(1));
                                                            }}
                                                            defaultValue={dayjs()}
                                                            shouldDisableDate = {(day) => {
                                                                return day > endDate;
                                                            }}
                                                        />
                                                        <DatePicker
                                                            label='종료일자'
                                                            format='YYYY-MM'
                                                            views={['year', 'month']}
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={endDate}
                                                            onChange={MonthlyEndDateChange}
                                                            slots={{ textField: TextField }}
                                                            disableFuture
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </Form>
                                        </div>
                                        <div className='search_button_area' style={{paddingTop:'8px'}}>
                                            <Button variant="primary" className='search_button'
                                                    onClick={handleChartSubmit}>검색</Button>
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <Form style={{width: 'auto', height:'30rem'}} id={dailyState}>
                                    <LineChart
                                        xAxis={[
                                            {
                                                data: date,
                                                scaleType: 'time',
                                                tickInterval: date,
                                                valueFormatter: (date) => `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`,
                                            }
                                        ]}
                                        yAxis={[{ min: 0 }]}
                                        series={[
                                            {
                                                curve: 'linear',
                                                data: cnt,
                                            },
                                        ]}
                                    />
                                    <h6 style={{display:'flex', justifyContent:'center'}}>일자</h6>
                                </Form>
                                <Form style={{width: 'auto', height:'30rem'}} id={weeklyState}>
                                    <LineChart
                                        xAxis={[
                                            {
                                                data: date,
                                                scaleType: 'time',
                                                tickInterval: date,
                                                valueFormatter: (date) => {
                                                    const day = dayjs(date);
                                                    const weekOfYear = day.week();
                                                    return `${day.year()}-${weekOfYear}`;
                                                }
                                            }
                                        ]}
                                        yAxis={[{ min: 0 }]}
                                        series={[
                                            {
                                                curve: 'linear',
                                                data: cnt,
                                            },
                                        ]}
                                    />
                                    <h6 style={{justifyContent:'center', display:'flex'}}>주차</h6>
                                </Form>
                                <Form style={{width: 'auto', height:'30rem'}} id={monthlyState}>
                                    <LineChart
                                        xAxis={[
                                            {
                                                data: date,
                                                scaleType: 'time',
                                                tickInterval: date,
                                                valueFormatter: (date) => {

                                                    const year = date.getFullYear();
                                                    const month = date.getMonth() + 1;

                                                    return `${year}-${month}`;
                                                }
                                            }
                                        ]}
                                        yAxis={[{ min: 0 }]}
                                        series={[
                                            {
                                                curve: 'linear',
                                                data: cnt,
                                            },
                                        ]}
                                    />
                                    <h6 style={{justifyContent:'center', display:'flex'}}>월차</h6>
                                </Form>
                            </Card.Body>
                            <Card.Body>
                                <TableContainer component={Paper}>

                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center">{selectedValueContent}</StyledTableCell>
                                                <StyledTableCell align="center">사용자 수</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map(userdata => (
                                                <TableRow key={userdata.date}>
                                                    {periodSelected === "2" ? (
                                                            <StyledTableCell align="center">{WeeklyFormat(userdata.date)}</StyledTableCell>
                                                        ) : (
                                                            <StyledTableCell align="center">{userdata.date}</StyledTableCell>
                                                    )}
                                                    <StyledTableCell align="center">{format(userdata.cnt)}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default ActiveUserChart;